import { MIGRATED_MUB_TYPES, normalizeMigType } from './migratedMubBannerVisibility';

/** Dashboard landing routes that can host the Premium migration dialog. */
export function isPremiumMigrationDashboardPath(pathname = '') {
  return /^\/(?:mspHome\/dashboard|dashboard|organization\/[^/]+\/dashboard)\/?$/.test(pathname);
}

/** Nearest dashboard route where GeneralSummary mounts migration dialogs. */
export function resolveMigrationDashboardPath(pathname = '') {
  if (isPremiumMigrationDashboardPath(pathname)) {
    return pathname;
  }

  try {
    const scopeId = localStorage.getItem('scopeId');
    if (scopeId === '2' && localStorage.getItem('currentNetwork')) {
      return '/dashboard';
    }
    if (scopeId === '1') {
      const selectedType = JSON.parse(localStorage.getItem('selectedType') || 'null');
      const orgLabel = selectedType?.label;
      if (orgLabel) {
        return `/organization/${encodeURIComponent(orgLabel)}/dashboard`;
      }
    }
  } catch (_) {
    // Fall through to MSP dashboard.
  }

  return '/mspHome/dashboard';
}

export function isValidMigrationTimestamp(value) {
  if (value === null || value === undefined || value === '' || value === 0 || value === '0') {
    return false;
  }

  const numericDate = Number(value);
  if (Number.isNaN(numericDate) || numericDate <= 0) {
    return false;
  }

  const timestamp = numericDate < 1000000000000 ? numericDate * 1000 : numericDate;
  const parsedDate = new Date(timestamp);

  return !Number.isNaN(parsedDate.getTime());
}

export function hasPremiumMigrationData(payload = {}) {
  const normalizedMigType = normalizeMigType(payload?.migType);
  const hasSupportedMigType =
    normalizedMigType === MIGRATED_MUB_TYPES.PREMIUM || normalizedMigType === MIGRATED_MUB_TYPES.PRO;

  if (hasSupportedMigType) {
    return true;
  }

  return isValidMigrationTimestamp(payload?.migDate);
}
